import { CheckBox } from "../core/components/checkBox.js";
import { FieldInstance } from "../core/components/field.js";
import { Helper } from "../core/util/helper.js";
import { GridArticle } from "../tasks/workPackage/workPackage.js";
import React from "react";

export const setOptions = (summarized: boolean, onlyParts: boolean, materialGridOptions: any): kendo.ui.GridOptions => {

    const addFunctionalColumns = (gridOptions: kendo.ui.GridOptions) => {
        gridOptions.columns.push({
            field: "Summarized",
            title: Helper.getTranslation("Artikel.Grouped"),
            template: "<input type='checkbox' #= data?.Summarized ? checked='checked':'' # disabled />",
            width: 100
        });
        gridOptions.columns.push({
            field: "CanBeUnpacked",
            title: Helper.getTranslation("Artikel.CanBeUnpacked"),
            width: 120
        });
        gridOptions.columns.push({
            field: "ResolvedBezeichnung",
            title: Helper.getTranslation("Artikel.DissolvedBy"),
            width: 100
        });
    };

    const hideColumns = (condition: boolean, columnsToHide: string[], gridOptions: kendo.ui.GridOptions) => {
        columnsToHide.forEach(p => {
            let column = gridOptions.columns.find(c => c.field === p);
            if (Helper.hasValue(column))
                column.hidden = condition;
        });
    };

    let options = JSON.stringify(materialGridOptions);
    let changedOptions = JSON.parse(options);
    addFunctionalColumns(changedOptions);
    let columnsToHide: string[] = ["Seriennr", "Chargennr", "Rechnungstext", "Maschnr", "Bemerkung", "Datum", "Rabatt", "Pos", "KmPos"];
    hideColumns(summarized, columnsToHide, changedOptions);
    changedOptions.columns.forEach(p => {
        if (p.field === "Summarized") {
            p.hidden = !summarized;
        }
        if (p.field === "CanBeUnpacked") {

            p.hidden = summarized;
            let canBeUnpackedInput = "<input type='checkbox' #= data?.CanBeUnpacked ? checked='checked':'' # disabled />";
            let isUnpackedUnput = "";
            if (onlyParts) {
                isUnpackedUnput = "<input type='checkbox' #= data?.IsUnpacked ? checked='checked':'' # disabled />";
                p.width = p.width as number + 110;
                p.title = Helper.getTranslation("Artikel.Dissolvable") + " " + Helper.getTranslation("Artikel.Dissolved");
            }
            else {
                p.title = Helper.getTranslation("Artikel.Dissolvable");
            }
            p.template = "<table><tr><td style=\"border:hidden;\">" + canBeUnpackedInput + "</td><td style=\"border:hidden;\">" + isUnpackedUnput + "</td></tr></table>";
        }
        if (p.field === "ResolvedBezeichnung") {
            p.hidden = summarized || onlyParts;
        }
    });

    return changedOptions;
}

export const getFilteredGridData = (summarized: boolean, onlyParents: boolean, gridData: GridArticle[]): any[] => {

    const getSummarizedParts = (gridData: GridArticle[]): GridArticle[] => {

        if (!Helper.hasValue(gridData)) return gridData;

        let positions: number[] = [];
        gridData.forEach(item => positions.push(item.Pos));

        positions.forEach(item => {
            let nextItem = gridData.find(p => p.Pos == item);
            if (Helper.hasValue(nextItem)) {
                let nextArtikelNr = nextItem.Artikelnr;
                let nextIsGuid = nextItem.IsGuid;
                let result = gridData.filter(p => p.Artikelnr == nextArtikelNr);

                if (result.length > 1) {
                    let anzahlSum: number = 0;
                    let anzahlPlMat: number = 0;
                    let anzahlLbMat: number = 0;
                    let GpreisSum: number = 0;
                    let kosten: number = 0;
                    let epreisSum: number = 0;
                    result.forEach(p => {
                        anzahlSum += p.Anzahl;
                        anzahlPlMat += p.AnzahlPlMat;
                        anzahlLbMat += p.AnzahlLbMat;
                        GpreisSum += p.Gpreis;
                        kosten += p.Kosten;
                        epreisSum += p.Epreis;
                    });
                    let epreis: number = epreisSum / result.length; //GpreisSum / anzahlSum;

                    nextItem.Anzahl = anzahlSum;
                    nextItem.AnzahlPlMat = anzahlPlMat;
                    nextItem.AnzahlLbMat = anzahlLbMat;
                    nextItem.Gpreis = GpreisSum;
                    nextItem.Summarized = true;
                    nextItem.Epreis = epreis;
                    nextItem.Kosten = kosten;
                    let itemsToDelete = result.filter(p => p.IsGuid != nextIsGuid);
                    itemsToDelete.forEach(toDelete => {
                        let index = gridData.findIndex(p => p == toDelete);
                        gridData.splice(index, 1);
                    });
                }
            }
        });

        return gridData;
    }


    const getGridDataCopy = (dataToCopy: GridArticle[]) => {
        let tempData = JSON.stringify(dataToCopy);
        let copy: GridArticle[] = JSON.parse(tempData);
        return copy;
    }

    let filtertGridData: GridArticle[] = getGridDataCopy(gridData);

    if (onlyParents) {
        filtertGridData = filtertGridData.filter(p => !Helper.hasValue(p.ResolvedFrom));
    }
    else {
        filtertGridData = filtertGridData.filter(p => !p.IsUnpacked);
    }
    if (summarized) {
        filtertGridData = getSummarizedParts(filtertGridData);
    }
    return filtertGridData;
}

export class AssemblyGroupViewElement extends React.Component<AssemblyGroupViewElementProps, AssemblyGroupViewElementState> {
    constructor(props) {
        super(props);
        this.state = {
            summarized: this.props.summarized,
            onlyParents: this.props.onlyParents
        };
    }

    private changeMode(id: string) {
        if (id === "summarizeMode") {
            let newOnlyParents = this.state.onlyParents;
            let newSummarized = !this.state.summarized;
            this.props.changeOptions(newSummarized, newOnlyParents);
            this.setState({
                summarized: newSummarized,
                onlyParents: newOnlyParents
            });
        }
        if (id === "parentOrPartsMode") {
            let newOnlyParents = !this.state.onlyParents;
            let newSummarized = this.state.summarized;
            this.props.changeOptions(newSummarized, newOnlyParents);
            this.setState({
                summarized: newSummarized,
                onlyParents: newOnlyParents
            });
        }
    }

    render() {
        let summarized = this.state.summarized ? Helper.getTranslation("Artikel.ArtikelGruppiert") : "";
        let onlyParents = this.state.onlyParents ? Helper.getTranslation("Artikel.TopLevelShown") : "";
        let warning = summarized + (this.state.summarized && this.state.onlyParents ? Helper.getTranslation("Artikel.And") + " " : "") + onlyParents;
        let backgroundColor = "yellow";
        let msg = this.state.summarized || this.state.onlyParents ? warning : "";
        const content = <div>
            <div style={{ display: "inline-flex", paddingRight: "10px", paddingBottom: "10px" }}>
                <FieldInstance noLabel={true}>
                    <CheckBox field={{ type: "n/a", model: "summarize", name: Helper.getTranslation("Artikel.ArtikelGruppieren"), labelAndControlCombined: true }}
                        value={this.state.summarized}
                        onChange={() => this.changeMode("summarizeMode")}
                        disabled={false} />
                </FieldInstance>
                <FieldInstance noLabel={true}>
                    <CheckBox field={{ type: "n/a", model: "onlyParents", name: Helper.getTranslation("Artikel.ShowTopLevel"), labelAndControlCombined: true }}
                        value={this.state.onlyParents}
                        onChange={() => this.changeMode("parentOrPartsMode")}
                        disabled={false} />
                </FieldInstance>
            </div>
            <div style={{ display: "inline-flex", padding: "3px 10px", height: "25px", backgroundColor: Helper.isNullOrEmpty(msg) ? "white" : "#ffd740", border: Helper.isNullOrEmpty(msg) ? "none" : "1.5px solid #ffab00", borderRadius: "6px", alignItems: "center" }}>
                <label>{msg}</label>
            </div>
        </div>;
        return (
            content
        );
    }
}

interface AssemblyGroupViewElementState {
    summarized: boolean;
    onlyParents: boolean;
}

interface AssemblyGroupViewElementProps {
    summarized: boolean;
    onlyParents: boolean;
    changeOptions: (newSummarized: boolean, newOnlyParents: boolean) => void;
}